import { useEffect, useRef, useState } from "react";
import { useAPI } from "../../providers/ApiProvider";

/**
 * Format lens: run the real converter over the task on screen and learn
 * (a) what the file output looks like in the chosen format and (b) which
 * results do not survive the conversion. JSON needs no lens — the record
 * pane already *is* the output.
 */
export const useExportLens = ({ projectId, format, shapedTask }) => {
  const api = useAPI();
  const [lens, setLens] = useState(null);
  const [loading, setLoading] = useState(false);
  const seq = useRef(0);

  useEffect(() => {
    if (!projectId || !shapedTask || !format || format === "JSON") {
      setLens(null);
      return;
    }
    const my = ++seq.current;
    setLoading(true);
    api
      .callApi("exportLens", {
        params: { pk: projectId },
        body: { format, tasks: [shapedTask] },
        errorFilter: () => true,
      })
      .then((res) => {
        if (my !== seq.current) return;
        setLens(res && res.format ? res : null);
        setLoading(false);
      });
  }, [api, projectId, format, shapedTask]);

  return { lens, loading };
};
